/**
 * Where the قرعه‌کشی landing can send someone, off this page.
 *
 * One module so a destination is never typed twice — a campaign link that
 * works in the hero and 404s in the footer is the kind of thing nobody
 * notices until a prospect reports it.
 */

/**
 * The app download page on the marketing site.
 *
 * Deliberately the *page*, not a store link: it already fans out to Cafe
 * Bazaar, Myket, Google Play and a direct APK, and which of those a given
 * Iranian phone can actually install is not something this page can guess.
 */
export const APP_DOWNLOAD_URL = 'https://hamyanapp.com/download'

/**
 * The Eitaa mini app.
 *
 * No `?startapp=` on purpose. Measured on a real device 2026-08-31: Eitaa
 * launches with a full signed payload and no start param at all — no
 * `tgWebAppStartParam` in the fragment, no `start_param` in initData — so a
 * code appended here is silently dropped and the visitor lands on the app's
 * front door instead of the page that invited them. The bare launch link is
 * honest about what it does: open Hamyan inside Eitaa.
 */
export const EITAA_MINIAPP_URL = 'https://eitaa.com/hamyan_minibot_app/start'

/**
 * The marketing site — «معرفی همیان».
 *
 * Deliberately not the download page: somebody who has not decided yet is
 * asking what this is, and answering with an install prompt is answering a
 * question they did not ask.
 */
export const HAMYAN_SITE_URL = 'https://hamyanapp.com'

/** The PWA itself, for «همین حالا در مرورگر». */
export const PWA_URL = 'https://pwa.hamyanapp.com/'

/** Where the demo fund lives, under a given invitation code. */
export const demoPath = (code?: string | null) =>
    code ? `/q/${code}/demo` : '/q/demo'

/** Back to the pitch from inside the demo. */
export const introPath = (code?: string | null) => (code ? `/q/${code}` : '/q')
